<div class="auto-size">
  <table
    bsFormOrchestrator
    #formOrchestrator="formOrchestrator"
    [tableOrchestratorChangeDetectorRef]="changeDetectorRef"
    [formOrchestratorData]="dataSource"
    [formOrchestratorIdPropertyName]="idPropertyName"
    [formOrchestratorDisplayColumns]="displayColumns"
    [dataSource]="formOrchestrator.matTableDataSource"
    [tableOrchestratorHasAction]="hasAction"
    [tableOrchestratorColumnsToDisplay]="formOrchestrator.columns"
    [tableOrchestratorActionPosition]="actionPosition"
    [tableOrchestratorExpandedElementViewMedia]="expandedElementViewMedia"
    [tableOrchestratorMediaIfDirective]="mediaIfDirective"
    [tableOrchestratorExpandedDetailQueryList]="expandedDetailQueryList"
    [tableOrchestratorActionQueryList]="actionQueryList"
    [tableOrchestratorChangeDetectorRef]="changeDetectorRef"
    [tableOrchestratorAutoSize]="autoSizeDirective"
    [tableOrchestratorEventAction]="eventAction"
    [keyTable]="keyTable"
    cdk-table
    multiTemplateDataRows
  >
    <ng-container
      [cdkColumnDef]="column"
      *ngFor="
        let column of formOrchestrator.tableOrchestratorColumnsToDisplay;
        let index = index
      "
    >
      <ng-container
        *ngIf="!displayColumns[index].columnHeaderIsVisible; else emptyHeader"
      >
        <th
          cdk-header-cell
          *cdkHeaderCellDef
          [class.sortable-header]="displayColumns[index].sortable"
          (click)="
            displayColumns[index].sortable
              ? onHeaderClick(displayColumns[index].sortKey ?? column)
              : null
          "
        >
          {{ displayColumns[index].columnLabel ?? column }}
          <span
            *ngIf="displayColumns[index].sortable"
            class="sort-icon"
            [class.sort-active]="
              sortState.column === (displayColumns[index].sortKey ?? column)
            "
          >
            <ng-container
              *ngIf="
                sortState.column === (displayColumns[index].sortKey ?? column);
                else noSort
              "
            >
              {{ sortState.direction === "asc" ? "↑" : "↓" }}
            </ng-container>
            <ng-template #noSort>⇅</ng-template>
          </span>
        </th>
      </ng-container>

      <ng-template #emptyHeader>
        <th cdk-header-cell *cdkHeaderCellDef></th>
      </ng-template>

      <td
        cdk-cell
        *cdkCellDef="let element"
        [class.has-image]="formOrchestrator.columnsType[index] === 'image'"
      >
        <ng-container *ngIf="formOrchestrator.columnsType[index] === 'counter'">
          <span class="text-overflow"
            ><span class="text">{{
              element[formOrchestrator.dataKeys[index]]
            }}</span></span
          >
        </ng-container>

        <ng-container *ngIf="formOrchestrator.columnsType[index] === 'data'">
          <span
            bsAutoAbbrev
            class="text-overflow"
            [class]="
              element[formOrchestrator.dataKeys[index]]?.toString() ?? ''
            "
            ><span
              class="text"
              [bsClickableCell]="
                formOrchestrator.columnIsClickable[index]?.cellIsClickable ??
                false
              "
              [clickableCellColor]="
                formOrchestrator.columnIsClickable[index]?.highlightColor
              "
              [clickableCellUrl]="
                formOrchestrator.columnIsClickable[index]?.url
              "
              [clickableCellWeight]="
                formOrchestrator.columnIsClickable[index]?.fontWeight
              "
              [clickableElementData]="element"
              [clickableCellQueryParams]="
                formOrchestrator.columnIsClickable[index]?.queryParamsFn
              "
              [clickableCellClickFn]="
                formOrchestrator.columnIsClickable[index]?.clickableCellClickFn
              "
            >
              {{
                element[formOrchestrator.dataKeys[index]]
                  | genericPipe
                    : formOrchestrator.columnsPipeType[index]
                    : formOrchestrator.columnsPipeParams[index]
              }}
            </span></span
          >
        </ng-container>

        <ng-container *ngIf="formOrchestrator.columnsType[index] === 'text'">
          <div class="field">
            <mat-form-field appearance="outline">
              <input
                [formControl]="
                  formOrchestrator.getControl(
                    element[formOrchestrator.formOrchestratorIdPropertyName],
                    formOrchestrator.columns[index]
                  )
                "
                matInput
                type="text"
              />
            </mat-form-field>
          </div>
        </ng-container>

        <ng-container *ngIf="formOrchestrator.columnsType[index] === 'number'">
          <div class="field">
            <mat-form-field appearance="outline">
              <input
                [formControl]="
                  formOrchestrator.getControl(
                    element[formOrchestrator.formOrchestratorIdPropertyName],
                    formOrchestrator.columns[index]
                  )
                "
                matInput
                type="number"
              />
            </mat-form-field>
          </div>
        </ng-container>

        <ng-container
          *ngIf="formOrchestrator.columnsType[index] === 'packaging-select'"
        >
          <ng-container
            *ngIf="
              getFormControlValue(element, index)?.selectOptions?.length;
              else packagingText
            "
          >
            <pdv-input-select
              [formControl]="formOrchestrator.getControl(element[formOrchestrator.formOrchestratorIdPropertyName], formOrchestrator.columns[index])"
              [options]="getFormControlValue(element, index)?.selectOptions ?? []"
              [config]="packagingSelectConfig"
              [compact]="true"
              (selectionChange)="onSelectChange(element, index, $event)"
            ></pdv-input-select>
            <p class="packaging-error" role="alert" *ngIf="getFormControlValue(element, index)?.selectError">
              {{ getFormControlValue(element, index)?.selectError }}
            </p>
          </ng-container>
          <ng-template #packagingText>
            <span class="text-overflow"
              ><span class="text">{{ element.embalagem }}</span></span
            >
          </ng-template>
        </ng-container>

        <ng-container *ngIf="formOrchestrator.columnsType[index] === 'image'">
          <img
            [bsNoImageFound]="noImage"
            [src]="element[formOrchestrator.dataKeys[index]]"
          />
        </ng-container>

        <ng-container
          *ngIf="formOrchestrator.columnsType[index] === 'incrementor'"
        >
          <bs-input-incrementor
            class="size"
            [maxIncrementor]="
              element.formGroupValue[
                getIndex(
                  formOrchestrator.columnsType[index],
                  element.formGroupValue,
                  index
                )
              ].maxIncrementor
            "
            *ngIf="
              element.formGroupValue[
                getIndex(
                  formOrchestrator.columnsType[index],
                  element.formGroupValue,
                  index
                )
              ]?.isVisible ?? true
            "
            [formControl]="
              formOrchestrator.getControl(
                element[formOrchestrator.formOrchestratorIdPropertyName],
                formOrchestrator.columns[index]
              )
            "
            [hasMultiple]="
              element.formGroupValue[
                getIndex(
                  formOrchestrator.columnsType[index],
                  element.formGroupValue,
                  index
                )
              ].hasMultiple
            "
            [removeProd]="
              element.formGroupValue[
                getIndex(
                  formOrchestrator.columnsType[index],
                  element.formGroupValue,
                  index
                )
              ].removeProd ?? true
            "
          ></bs-input-incrementor>
        </ng-container>

        <ng-container
          *ngIf="formOrchestrator.columnsType[index] === 'value-hover'"
        >
          <bs-value-hover
            [firstValue]="
              element.formGroupValue[
                getIndex(
                  formOrchestrator.columnsType[index],
                  element.formGroupValue,
                  index
                )
              ].firstValue
            "
            [secondValue]="
              element.formGroupValue[
                getIndex(
                  formOrchestrator.columnsType[index],
                  element.formGroupValue,
                  index
                )
              ].secondValue
            "
            [formControl]="
              formOrchestrator.getControl(
                element[formOrchestrator.formOrchestratorIdPropertyName],
                formOrchestrator.columns[index]
              )
            "
          ></bs-value-hover>
        </ng-container>

        <ng-container
          *ngIf="formOrchestrator.columnsType[index] === 'observation'"
        >
          <bs-observation
            *ngIf="
              formOrchestrator.getControl(
                element[formOrchestrator.formOrchestratorIdPropertyName],
                formOrchestrator.columns[index]
              ) as control
            "
            [formControl]="control"
            [isEditable]="
              element.formGroupValue[
                getIndex(
                  formOrchestrator.columnsType[index],
                  element.formGroupValue,
                  index
                )
              ].isEditable
            "
            [ambientes]="
              element.formGroupValue[
                getIndex(
                  formOrchestrator.columnsType[index],
                  element.formGroupValue,
                  index
                )
              ].ambientes
            "
          ></bs-observation>
        </ng-container>

        <ng-container *ngIf="formOrchestrator.columnsType[index] === 'remove'">
          <bs-remove
            [formControl]="
              formOrchestrator.getControl(
                element[formOrchestrator.formOrchestratorIdPropertyName],
                formOrchestrator.columns[index]
              )
            "
            [content]="
              element.formGroupValue[
                getIndex(
                  formOrchestrator.columnsType[index],
                  element.formGroupValue,
                  index
                )
              ].content
            "
          ></bs-remove>
        </ng-container>

        <ng-container
          *ngIf="formOrchestrator.columnsType[index] === 'retirada'"
        >
          <bs-retirada
            [formControl]="
              formOrchestrator.getControl(
                element[formOrchestrator.formOrchestratorIdPropertyName],
                formOrchestrator.columns[index]
              )
            "
            [isEditable]="
              element.formGroupValue[
                getIndex(
                  formOrchestrator.columnsType[index],
                  element.formGroupValue,
                  index
                )
              ].isEditable
            "
          ></bs-retirada>
        </ng-container>

        <ng-container
          *ngIf="formOrchestrator.columnsType[index] === 'desconto'"
        >
          <div class="bs-container" style="display: flex; align-items: center">
            <bs-desconto
              [formControl]="
                formOrchestrator.getControl(
                  element[formOrchestrator.formOrchestratorIdPropertyName],
                  formOrchestrator.columns[index]
                )
              "
              [unitaryValue]="
                element.formGroupValue[
                  getIndex(
                    formOrchestrator.columnsType[index],
                    element.formGroupValue,
                    index
                  )
                ].unitaryValue
              "
              [currentDiscount]="
                element.formGroupValue[
                  getIndex(
                    formOrchestrator.columnsType[index],
                    element.formGroupValue,
                    index
                  )
                ].currentDiscount
              "
              [oldValue]="
                element.formGroupValue[
                  getIndex(
                    formOrchestrator.columnsType[index],
                    element.formGroupValue,
                    index
                  )
                ].oldValue
              "
              [id]="
                element.formGroupValue[
                  getIndex(
                    formOrchestrator.columnsType[index],
                    element.formGroupValue,
                    index
                  )
                ].id
              "
              [descontoRodaPe]="
                element.formGroupValue[
                  getIndex(
                    formOrchestrator.columnsType[index],
                    element.formGroupValue,
                    index
                  )
                ].descontoRodaPe
              "
              [maxPercentDiscount]="
                element.formGroupValue[
                  getIndex(
                    formOrchestrator.columnsType[index],
                    element.formGroupValue,
                    index
                  )
                ].maxPercentDiscount
              "
            ></bs-desconto>

            <mat-checkbox
              style="margin-left: 20px; margin-bottom: 8.5px"
              *ngIf="
                element.formGroupValue[
                  getIndex(
                    formOrchestrator.columnsType[index],
                    element.formGroupValue,
                    index
                  )
                ].hasCheckbox
              "
            ></mat-checkbox>
          </div>
        </ng-container>

        <ng-container
          *ngIf="formOrchestrator.columnsType[index] === 'checkbox'"
        >
          <bs-checkbox
            [formControl]="
              formOrchestrator.getControl(
                element[formOrchestrator.formOrchestratorIdPropertyName],
                formOrchestrator.columns[index]
              )
            "
          ></bs-checkbox>
        </ng-container>

        <ng-container
          *ngIf="formOrchestrator.columnsType[index] === 'edit-client'"
        >
          <bs-edit-user
            [formControl]="
              formOrchestrator.getControl(
                element[formOrchestrator.formOrchestratorIdPropertyName],
                formOrchestrator.columns[index]
              )
            "
          ></bs-edit-user>
        </ng-container>
      </td>
    </ng-container>

    <ng-container cdkColumnDef="actions">
      <th cdk-header-cell *cdkHeaderCellDef></th>
      <td cdk-cell *cdkCellDef="let element">
        <div class="td-actions" style="cursor: pointer">
          <div #actionCellViewContainerRef></div>
        </div>
      </td>
    </ng-container>

    <tr
      [bsExpandedRow]="expandedElementViewMedia"
      [tableElement]="element"
      cdk-row
      *cdkRowDef="let element; columns: formOrchestrator.tableColumns"
      class="element-row"
    ></tr>
    <tr cdk-header-row *cdkHeaderRowDef="formOrchestrator.tableColumns"></tr>

    <ng-container *bsMediaIf="expandedElementViewMedia; mode: 'gt'">
      <ng-container cdkColumnDef="expandedDetail">
        <td cdk-cell *cdkCellDef="let element">
          <div
            bsAutoSize
            [@detailExpand]="
              element === formOrchestrator.expandedElement
                ? 'expanded'
                : 'collapsed'
            "
            class="element-detail"
          >
            <div #expandedDetailViewContainerRef></div>
          </div>
        </td>
      </ng-container>
      <tr
        cdk-row
        *cdkRowDef="let row; columns: ['expandedDetail']"
        class="detail-row"
      ></tr>
    </ng-container>
  </table>
</div>
